export enum LogSeverity {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
}

export interface LoggingSink {
  log(severity: LogSeverity, timestamp: string, message: string): void;
}
